module.exports = __webpack_public_path__ + "static/media/goForwardSFX.bfc0521d.mp3";